import { Box } from "@mui/material";
import { SxProps } from "@mui/material";

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
  onClick?: () => void;
};

export const CardStyle = ({ sx = [], children, onClick }: Props) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: "white",
          p: { xs: 2, sm: 3 },
          borderRadius: 4,
          cursor: onClick ? "pointer" : "default",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};
